import { Backdrop, CircularProgress } from "@mui/material";
import { useLoader } from "../../hooks/useLoaderContext/useLoaderContext";

// Global loader component
const GlobalLoader: React.FC = () => {
  const { isLoading } = useLoader();

  if (!isLoading) return null;
  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={true}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default GlobalLoader;
